import React from "react";

import * as styles from "./styles";

interface TextInputProps extends styles.InputProps {
  hasError?: boolean;
  helperText?: React.ReactElement;
  label?: string;
}

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/display-name
export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  ({ hasError, helperText, label, onChange, type, value, ...inputProps }: TextInputProps, ref) => (
    <styles.Container error={hasError}>
      {label && <styles.Label>{label}</styles.Label>}
      <styles.Input {...inputProps} type={type} value={value} onChange={onChange} ref={ref} />
      {helperText && <styles.HelperText>{helperText}</styles.HelperText>}
    </styles.Container>
  )
);

TextInput.defaultProps = {
  hasError: false,
  type: "text",
};
